export const questions = {
    ispair: "Czy te buty stanowią parę?",
    aisleft: "Czy but z górnego wiersza pasuje na lewą nogę?",
    sex: "Dla jakiej płci przeznaczone są te buty?",
    age: "Czy te buty przeznaczone są dla dzieci?",
    season: "Na jaki sezon przeznaczone są te buty?",
    size: "Jaki rozmiar mają te buty?",
    soletype: "Jaki rodzaj podeszwy mają te buty?",
    lock: "Jaki rodzaj zapięcia posiadają te buty?",
    style: "Jaki styl mają te buty?",
    condition: "Jaki stan mają te buty?",
};

export const tooltips = {
    ispair: "Czy oba buty zostały prawidłowo sparowane? Przykładowo – dwa buty lewe lub para, gdzie buty mają różny rozmiar nie jest prawidłową parą. " +
        "Aby upewnić się czy oba buty stanowią parę należy zwrócić uwagę na przyszwę jak i na podeszwę",
    aisleft: "Należy wybrać TAK w przypadku gdy lewy but jest przedstawiony w górnym wierszu a prawy w dolnym.",
    sex: "Kategoria, gdzie należy oznaczyć z jak najwyższym prawdopodobieństwem czy buty są dedykowane dla płci damskiej, męskiej czy są unisex. " +
        "Uwaga – buty, które okazjonalnie mogłaby założyć kobieta choć normalnie uznało by się je za męskie należy oznaczać jako męskie – nie unisex.",
    age: "Przez buty dziecięce rozumiemy buty w małych rozmiarach wyraźnie rozpoznawalne jako but dziecięcy.",
    season: "Przytrzymaj kursor nad odpowiedzią aby uzyskać dodatkowe informacje.",
    size: "Przytrzymaj kursor nad odpowiedzią aby uzyskać dodatkowe informacje.",
    soletype: "Przytrzymaj kursor nad odpowiedzią aby uzyskać dodatkowe informacje.",
    lock: "Wybierz metody zapięcia nawet jeśli pełnią tylko funkcję dekoracyjną.",
    style: "Przytrzymaj kursor nad odpowiedzią aby uzyskać dodatkowe informacje.",
    condition: "Kategoria ta określa ogólny stan zużycia buta. Przytrzymaj kursor nad odpowiedzią aby uzyskać dodatkowe informacje.",
}
export const tabs = [
    {name: "ispair", label: "para"},
    {name: "aisleft", label: "ułożenie"},
    {name: "sex", label: "płeć"},
    {name: "age", label: "wiek"},
    {name: "season", label: "sezon"},
    {name: "size", label: "rozmiar"},
    {name: "soletype", label: "podeszwa"},
    {name: "lock", label: "zapięcie"},
    {name: "style", label: "rodzaj"},
    {name: "condition", label: "stan"}
];
export const values = {
    ispair: [
        [{label: "tak", value: "YES", tooltip: null},
            {label: "nie", value: "NO", tooltip: null}]
    ],
    aisleft: [
        [{label: "tak", value: "YES", tooltip: null},
            {label: "nie", value: "NO", tooltip: null}]
    ],
    sex: [
        [{label: "kobieta", value: "WOMAN", tooltip: null},
            {label: "mężczyzna", value: "MAN", tooltip: null},
            {label: "unisex", value: "UNI", tooltip: null}]
    ],
    age: [
        [{label: "tak", value: "CHILD", tooltip: null},
            {label: "nie", value: "ADULT", tooltip: null}]
    ],
    season: [
        [{label: "letni", value: "SUMMER", tooltip: "Buty przewiewne, lekkie, noszone głównie latem. Konstrukcja buta jest dedykowana do pory letniej."},
            {label: "zimowy", value: "WINTER", tooltip: "Buty zamknięte, zwykle wysokie, często z ociepleniem."},
            {label: "inny", value: "ALLYEAR", tooltip: "Buty, dla których nie da się jednoznacznie przypisać cechy butów letnich lub zimowych."}]
    ],
    size: [
        [{label: "xs", value: "XS", tooltip: "Buty dla dzieci w wieku przedszkolnym lub wcześniejszym."},
            {label: "s", value: "S", tooltip: "Buty dziecięce w wieku szkolnym, młodzieżowe jak i szczególnie małe rozmiary butów dla osób dorosłych."},
            {label: "m", value: "M", tooltip: "Sam środek skali: buty damskie, młodzieżowe męskie jak i troszkę dorosłych męskich."},
            {label: "l", value: "L", tooltip: "Buty duże. Najczęściej duże buty męskie, jednak dopuszczane są również damskie."},
            {label: "xl", value: "XL", tooltip: "Buty w szczególnie dużym rozmiarze."}]
    ],
    soletype: [
        [{label: "płaska", value: "FLAT", tooltip: "Płaska podeszwa bez oznaczonego obcasa lub z bardzo małym obcasem około 1cm. W tym korki."},
            {label: "niski obcas", value: "LOW_HEEL", tooltip: "Szeroki obcas o wysokości do kilku centymetrów."},
            {label: "wysoki obcas", value: "HIGH_HEEL", tooltip: "Szeroki bardzo wysoki obcas."}],
        [{label: "szpilka", value: "STILETTO", tooltip: "Wąski obcas w kształcie szpilki niezależnie od wysokości."},
            {label: "koturn", value: "COTHURNUS", tooltip: "Gruba podeszwa podwyższona jak w obcasie jednak bez wyodrębnionego obcasa."}]
    ],
    lock: [
        [{label: "sznurówki", value: "lock_laces", tooltip: null},
            {label: "rzep", value: "lock_velcro", tooltip: null},
            {label: "suwak", value: "lock_zip", tooltip: null},
            {label: "klamra", value: "lock_buckle", tooltip: null}]
    ],
    style: [
        [{label: "kapcie", value: "style_slipper", tooltip: "Ogólnie pojęta kategoria obuwia domowego."},
            {label: "klapki", value: "style_flipflop", tooltip: "Buty o odsłoniętej, niczym nie przytrzymywanej pięcie. Zwykle odsłonięte są również palce."},
            {label: "sandały", value: "style_sandal", tooltip: "Buty z cholewą wykonaną z pasów materiału lub ażurowaną otwartą."}],

        [{label: "trampki", value: "style_chucks", tooltip: "Lekkie letnie buty sportowe o zamkniętej budowie i płaskiej, gumowej podeszwie. Charakterystyczne jest pokrycie gumą noska buta."},
            {label: "inne sportowe", value: "style_sport", tooltip: "Pozostałe buty sportowe inne niż trampki."}],

        [{label: "półbuty casual", value: "style_casualderby", tooltip: "Buty wyjściowe, często noszące cechy butów sportowych jednak takimi nie będące z powodu materiału, z którego są wykonane. Są to również buty z pogranicza butów garniturowych – np. skórzane, których krój jednak nie pozwala uznać ich za elegancki but do garnituru."},
            {label: "półbuty garniturowe", value: "style_derby", tooltip: "Buty męskie, pasujące do garnituru (nie wyższe niż do kostki)."}],

        [{label: "baleriny", value: "style_ballerina", tooltip: "Damskie buty o bardzo niskiej budowie i cienkiej podeszwie – czasem z dodanym niskim obcasem."},
            {label: "czółenka", value: "style_pump", tooltip: "Damskie buty o bardzo niskiej, smukłej budowie i cienkiej podeszwie z szerokim obcasem. Odkryte śródstopie. Balerinki na obcasie."},
            {label: "lordsy", value: "style_lords", tooltip: "Eleganckie wsuwane buty o cholewie poniżej kostki o charakterystycznym przedłużeniu w miejscu języka. Zarówno męskie jak i damskie."}],

        [{label: "sztyblety", value: "style_chelsea", tooltip: "Buty powyżej kostki zwykle z niewielkim obcasem. Cholewa wykonana z dużych części materiału pozbawiona nadmiaru elementów ozdobnych. Górna część cholewy zwykle ma dodany element elastyczny."},
            {label: "kozaki", value: "style_boot", tooltip: "Buty zamknięte o wysokiej cholewie."},
            {label: "kowbojki", value: "style_cowboy", tooltip: "Buty skórzane, zwykle z wysoką cholewką. Obcas ścięty ku przodowi."}],

        [{label: "szpilki", value: "style_highheel", tooltip: "Buty o dowolnej budowie cholewy lecz o charakterystycznym cienkim obcasie."},
            {label: "platformy", value: "style_platform", tooltip: "Buty charakteryzujące się ponadprzeciętną grubością podeszwy. Pozostała część buta jest tu całkowicie dowolna."}],

        [{label: "trapery", value: "style_hiking", tooltip: "Buty o wysokiej cholewie ponad kostkę. Podeszwa charakteryzuje się dużym bieżnikiem i wyższym podbiciem na pięcie – zwykle z niskim obcasem lub bez. Nosek buta okrągły i wzmocniony. Zwykle sznurowane."},
            {label: "workery/wojskowe", value: "style_heavy", tooltip: "Buty często przypominające trapery jednak o masywniejszej budowie. W przypadku workerów (butów roboczych) mają jeszcze bardziej wzmocniony czubek buta."}],

        [{label: "chodaki", value: "style_clog", tooltip: "Wsuwane buty na drewnianej podeszwie."},
            {label: "kalosze", value: "style_wellington", tooltip: "Buty gumowe i nieprzemakalne."}],

    ],
    condition: [
        [{label: "doskonały", value: "EXCELLENT", tooltip: "But nie noszący żadnych oznak użytkowania."}],
        [{label: "lekko zużyte", value: "SMALL_WEAR", tooltip: "Buty wyglądające na prawie nowe z lekkimi śladami użytkowania."},
            {label: "średnio zużyte", value: "MEDIUM_WEAR", tooltip: "Buty średnio zniszczone."},
            {label: "mocno zużyte", value: "HEAVY_WEAR", tooltip: "Buty o wyraźnie przytartej podeszwie lub mocno poobcierane i rozciągnięte."}],
        [{label: "zniszczone", value: "WORNOUT", tooltip: "Buty nie nadające się do dalszej dystrybucji. Pęknięte podeszwy, dziury, przetarcia, pęknięcia."}]
    ],
}
